import { render, staticRenderFns } from "./HotelsList.vue?vue&type=template&id=3a76801b"
import script from "./HotelsList.vue?vue&type=script&lang=js"
export * from "./HotelsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotelsSortSelect: require('/home/forge/ab.farescraper.com/components/HotelsSortSelect.vue').default,HotelsFilters: require('/home/forge/ab.farescraper.com/components/HotelsFilters.vue').default,HotelsMapCard: require('/home/forge/ab.farescraper.com/components/HotelsMapCard.vue').default,HotelsMap: require('/home/forge/ab.farescraper.com/components/HotelsMap.vue').default})
